module.exports = __webpack_public_path__ + "static/media/focus.de418295.png";